// src/services/api.js
import axios from "axios";
import Swal from "sweetalert2";
import { getServerUrls } from "./urls";

const SERVERS = [
  // "http://localhost:8000/api",
  // "https://school.trackingacademy.in/backend/public/api",
  // "https://institute.dturn.io/backend/public/api",
  "https://kidspark.trackingacademy.in/backend/public/api",
  // "https://bonnenehrunp.trackingacademy.in/backend/public/api",
  // "https://bonnenehruhr.trackingacademy.in/backend/public/api",
  // "https://bestschool.trackingacademy.in/backend/public/api",


];

// `activeBaseUrl` persists across sessions, so a login from before the server
// list changed would keep calling the old backend — and its device token would
// stay in that backend's app_device_tokens, where the new backend can never
// find it to send a push. Drop it and force a re-login instead.
let storedBaseUrl = localStorage.getItem("activeBaseUrl");
if (storedBaseUrl && !SERVERS.includes(storedBaseUrl)) {
  localStorage.clear(); // same as logout — the old session's token is not valid here
  storedBaseUrl = null;
}

const api = axios.create({
  baseURL: storedBaseUrl || "", // Will be set after login
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 0,
});

export async function logindata(data) {
  for (const server of SERVERS) {
    try {
      const response = await axios.post(`${server}/login`, data);
      const result = response.data;

      if (result.status === true) {
        localStorage.setItem("activeBaseUrl", server);
        api.defaults.baseURL = server;
        const { exportUrl, reportUrl } = getServerUrls();
        localStorage.setItem("exportUrl", exportUrl);
        localStorage.setItem("reportUrl", reportUrl);
        
        return result; // successful login
      }
    } catch (error) {
      console.log(`Login failed on ${server}`);
    }
  }

  // Swal.fire("Login Failed", "All servers are unreachable", "error");
  return { status: false, message: "Login failed" };
}

export default api;
